import Vue from "vue";
import API from "../../../../config/api";

async function getUserInfo() {
    let header = {
        "Content-Type": "application/x-www-form-urlencoded"
    }
    let ret = await Vue.prototype.$axiosRequest({
        url: API.getUserInfo,
        method: 'GET',
        data: {},
        header: header,
    });
    ret = ret[1];
    console.log(ret);
    window.localStorage.setItem("user", JSON.stringify(ret.data.userInfo))
    Vue.prototype.$bus.$emit('header-refresh')
    return ret;
}
export default getUserInfo